import { useCallback, useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { updateSelectedFormItem, resetSelectedFormItem
//@ts-expect-error untyped file
} from 'FormsUI/actions/FormSelection';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import TourContext from 'ui-shepherd-react/contexts/TourContext';
import { finishTour } from 'FormsUI/utils/TourUtils';
import usePaymentField from './usePaymentField';
const usePaymentPanel = () => {
  const dispatch = useDispatch();
  const {
    tour
  } = useContext(TourContext);
  const {
    paymentField
  } = usePaymentField();
  const handlePaymentSelect = useCallback(() => {
    finishTour(tour);
    dispatch(updateSelectedFormItem(paymentField.fieldType, getPropertyObjectTypeId(paymentField)));
  }, [dispatch, tour, paymentField]);
  const handlePaymentDeselect = useCallback(() => {
    dispatch(resetSelectedFormItem({
      updateRoute: true
    }));
  }, [dispatch]);
  return useMemo(() => ({
    handlePaymentSelect,
    handlePaymentDeselect
  }), [handlePaymentSelect, handlePaymentDeselect]);
};
export default usePaymentPanel;